import { render, staticRenderFns } from "./SaleBillingDetail.vue?vue&type=template&id=ca928e64&"
import script from "./SaleBillingDetail.vue?vue&type=script&lang=js&"
export * from "./SaleBillingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports